module.exports = "<div>\n    <i class=\"fas fa-exclamation-circle fa-lg px-1 mx-2\"></i> {{ msg }}\n</div>"